import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryNav() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            分类导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            探索漫画分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-xl mx-auto">
            按不同风格和类型浏览刃牙漫画及相关作品，找到你最喜欢的格斗漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-lg p-6 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                {cat.slug === 'fighting' && <i className="ri-boxing-line text-xl"></i>}
                {cat.slug === 'hot-blooded' && <i className="ri-fire-line text-xl"></i>}
                {cat.slug === 'classic' && <i className="ri-medal-line text-xl"></i>}
                {cat.slug === 'latest' && <i className="ri-rocket-line text-xl"></i>}
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{cat.count} 部作品</span>
                <span className="text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                  浏览 →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}